export default __webpack_public_path__ + "static/media/logo-light.84197b4f.svg";